import React from "react";

import { Tab, Tabs } from "react-bootstrap";

import { withTranslation } from "react-i18next";
import FileUploadTab from "./tabs/fileUploadTab/FileUploadTab";
import FileOverviewTab from "./tabs/fileOverviewTab/FileOverviewTab";
import CamplaCoreService from "../../../../../../services/CamplaCoreService";
import APIErrorHelper from "../../../../../../helpers/APIErrorHelper";
import BaseDialog from "../../../../../../components/dialogs/baseDialog/BaseDialog";

import equals from "fast-deep-equal";

class StudentExaminationFileManager extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            studentExaminationFiles: [],
            dialogApiError: ""
        };

        this.fetchData = this.fetchData.bind(this);
        this.handleHide = this.handleHide.bind(this);
        this.handleUpload = this.handleUpload.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
    }

    componentDidUpdate(prevProps) {
        if (!equals(prevProps.instance, this.props.instance)) {
            this.fetchData();
        }
    }

    async fetchData() {
        try {
            const studentExaminationFiles = await CamplaCoreService.getAllStudentExamFilesByInstance(
                this.props.instance._id
            );
            this.setState({ studentExaminationFiles });
        } catch (err) {
            this.setState({
                dialogApiError: APIErrorHelper.getError(
                    err,
                    () => this.setState({ dialogApiError: "" }),
                    {},
                    this.props.t
                )
            });
        }
    }

    async handleDelete(id) {
        try {
            await CamplaCoreService.deleteStudentExamFile(this.props.instance._id, id);
            const newStudentExaminationFiles = this.state.studentExaminationFiles.filter(sf => id !== sf._id);
            this.setState({ studentExaminationFiles: newStudentExaminationFiles });
        } catch (err) {
            this.setState({
                dialogApiError: APIErrorHelper.getError(
                    err,
                    () => this.setState({ dialogApiError: "" }),
                    {
                        PRECONDITION_FAILED:
                            "SingleExamination.InstanceTab.StudentExaminationFilesDialog.APIError.PreconditionFailed",
                        NOT_FOUND:
                            "SingleExamination.InstanceTab.StudentExaminationFilesDialog.APIError.NotFound",
                        CONFLICT: "SingleExamination.InstanceTab.StudentExaminationFilesDialog.APIError.Conflict"
                    },
                    this.props.t
                )
            });
        }
    }

    async handleUpload(files) {
        if (!this.props.instance) return [];

        const newStudentExaminationFiles = [];
        for (const idx in files) {
            try {
                newStudentExaminationFiles.push(
                    await CamplaCoreService.uploadStudentExamFile(this.props.instance._id, files[idx]));
                files[idx]["status"] = 1;
            } catch (err) {
                files[idx]["status"] = 2;
                this.setState({
                    dialogApiError: APIErrorHelper.getError(
                        err,
                        () => this.setState({ dialogApiError: "" }),
                        {
                            PRECONDITION_FAILED:
                                "SingleExamination.InstanceTab.StudentExaminationFilesDialog.APIError.PreconditionFailed",
                            NOT_FOUND:
                                "SingleExamination.InstanceTab.StudentExaminationFilesDialog.APIError.NotFound",
                            BAD_REQUEST:
                                "SingleExamination.InstanceTab.StudentExaminationFilesDialog.APIError.BadRequest",
                            CONFLICT:
                                "SingleExamination.InstanceTab.StudentExaminationFilesDialog.APIError.Conflict"
                        },
                        this.props.t
                    )
                });
            }
        }
        const studentExaminationFiles = await CamplaCoreService.getAllStudentExamFilesByInstance(
            this.props.instance._id
        );
        this.setState({studentExaminationFiles});
        return files;
    }

    handleHide() { this.props.onHide(); }

    render() {
        const { t } = this.props;
        return (
            <BaseDialog
                show={this.props.show}
                onHide={this.handleHide}
                title={t("SingleExamination.InstanceTab.StudentExaminationFilesDialog.Title")}
                leftButtonText={t("DialogClose")}
                leftButtonVariant="black"
                leftButtonCallback={this.handleHide}
                body={(<Tabs defaultActiveKey="fileUpload">
                    <Tab
                        eventKey="fileOverview"
                        tabClassName="item-link"
                        title={t(
                            "SingleExamination.InstanceTab.StudentExaminationFilesDialog.FileOverviewTabTitle"
                        )}
                    >
                        <FileOverviewTab
                            onDelete={this.handleDelete}
                            studentExaminationFiles={this.state.studentExaminationFiles}
                        />
                    </Tab>
                    <Tab
                        eventKey="fileUpload"
                        tabClassName="item-link"
                        title={t(
                            "SingleExamination.InstanceTab.StudentExaminationFilesDialog.FileUploadTabTitle"
                        )}
                    >
                        <FileUploadTab
                            instance={this.props.instance}
                            instanceTemplate={this.props.instanceTemplate}
                            studentExaminationFiles={this.state.studentExaminationFiles}
                            onUpload={this.handleUpload}
                        />
                    </Tab>
                </Tabs>)}
            />
        );
    }
}

export default withTranslation()(StudentExaminationFileManager);
